import { useCallback, useEffect, useMemo, useState } from 'react'

import { Drawer } from 'antd'
import SmartTable, { SmartTableDataTypes } from '../shared/SmartTable'
import { downloadFile, isNonEmptyArray, request } from '../../utils'
import { makeUrlParameters, slugify } from '../../utils/dataFactories'
import { STANDARD_DRAWER_WIDTH } from '../../utils/constants'
import isObject from 'lodash'
import { useSelector } from 'react-redux'
import { selectUser } from '../../reducers/UserReducer'
import { HttpMethods } from '../../utils/apiHelper'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { getInstitutionTemplates, getTemplateVariables } from '../../utils/api/institution'
import { getters } from '../../utils/entities/student'

const WITHOUT_SCHOOL_TEXT = 'Ecole inconnue'
const WIHTOUT_SECTION_TEXT = 'Sans section'
const WITHOUT_SECTIONTOYEAR_TEXT = 'Sans année scolaire'

const PublipostageDrawer = ({ student, onClose }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [school, setSchool] = useState(null)
  const [templates, setTemplates] = useState([])

  useEffect(() => {
    if (isNonEmptyArray(user.institutions)) {
      getInstitutionTemplates(user, user.institutions[0]).then(({ data }) => setTemplates(data))
    }
  }, [user.id])

  const localStudent = useMemo(() => {
    const localStudent = isObject(student) ? student : null

    if (localStudent !== null && !localStudent.school) {
      if (localStudent.sections?.[0]?.school) {
        localStudent.school = localStudent.sections[0].school.name
        localStudent.sectionToYear = localStudent.sections[0].sectionToYear ? localStudent.sections[0].sectionToYear.schoolYearName : WITHOUT_SECTIONTOYEAR_TEXT
      } else {
        localStudent.school = school ? school.name : WITHOUT_SCHOOL_TEXT
      }
    }

    return localStudent
  }, [student, school])

  useEffect(() => {
    if (student && !student.school) {
      request(
        `/students/${student.id}/school?section-name=${student.section}`,
        HttpMethods.GET,
        null,
        user
      ).then(json => setSchool(json.data))
    }
  }, [student, user])

  const onFileDownload = useCallback(template => {
    getTemplateVariables(user, template).then(({ data }) => {
      const filenameParts = template.originalName.split('.')
      const studentSection = getters.sectionFullAbbreviation(localStudent)

      filenameParts.pop()
      filenameParts.push(localStudent.lastname, localStudent.firstname)

      downloadFile(
          `/api/institution-templates/${template.id}/process` +
            makeUrlParameters({ ...localStudent, section: studentSection === '' ? WIHTOUT_SECTION_TEXT : studentSection }, data),
          slugify(filenameParts.join(' ') + '.' + template.extension),
          user
      )
    })
  }, [localStudent, user])

  const columns = useMemo(() => [
    { type: SmartTableDataTypes.ID, key: 'id' },
    { type: SmartTableDataTypes.STRING, name: t('Template'), key: 'originalName' }
  ], [t])

  return (
    <Drawer
      title={t('Student Publipostage')}
      width={STANDARD_DRAWER_WIDTH}
      onClose={onClose}
      visible={!!localStudent}
    >
      <SmartTable
        columns={columns}
        data={templates}
        addLineOnAddData={false}
        loading={false}
        noDataText={t(
          'There is no template available. If you desire to add a template, please contact Opal Solutions.'
        )}
        additionalActions={[
          { iconName: 'download', type: 'primary', title: t('Download file'), onClick: (i) => onFileDownload(i) }
        ]}
      />
    </Drawer>
  )
}

export default PublipostageDrawer
